import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./Products.css";
import Footer from "../../components/Footer";

// Import local images from assets - use directly (no database calls for faster loading)
import grcImage from "../../assets/Products/GRC/grc 1.webp";
import lapsecImage from "../../assets/Products/Lapsec/lapsec 2.webp";
import truckImage from "../../assets/Products/Smart Trucks/truck 1.jpg";
import cyberImage from "../../assets/Products/Cyber/cyber.webp";
import roboticsImage from "../../assets/Products/Robotics/robotics 1.webp";
import auditImage from "../../assets/Products/ProSync/audit.webp";

const Products = () => {
  const history = useHistory();
  
  // Products data - using local images directly for instant loading
  const products = [
      {
        id: 1,
        title: "RiskaVaire",
        route: "https://vardaands.com/riskavaire",
      image: grcImage,
        description: "RiskaVaire is Vardaan Global's AI‑powered GRC (Governance, Risk & Compliance) platform that uses predictive analytics to identify, evaluate, and proactively mitigate business risks."
      },
      {
        id: 2,
        title: "ProSync",
        route: "https://vardaands.com/prosync",
      image: auditImage,
        description: "ProSync is an integrated platform that automates critical business workflows, boosts productivity, and delivers real‑time operational insights."
      },
      {
        id: 3,
        title: "ViCTAA",
        route: "https://vardaands.com/ViCTAA",
      image: lapsecImage,
        description: "ViCTAA is a proactive, friction-less endpoint security platform designed to simplify compliance and safeguard an organization's digital and physical assets."
      },
      {
        id: 4,
        title: "Smart Logistics",
        route: "https://vardaands.com/smartlogistics",
      image: truckImage,
        description: "SmartLogistics is an AI- and IoT-driven supply-chain platform that gives real‑time visibility, predictive insights, and smart automation to optimize logistics operations."
      },
      {
        id: 5,
        title: "Cybersecurity as a Service",
        route: "https://www.vardaan-cyber.com/",
      image: cyberImage,
        description: "Vardaan Cybersecurity delivers advanced, continuous protection with threat detection, risk management, and incident response."
      },
      {
        id: 6,
        title: "Robotic Solutions & Services",
        route: "https://www.recodesolutions.com/",
      image: roboticsImage,
        description: "Professional automation solutions that enhance efficiency across manufacturing, logistics, and service operations."
      }
    ];

  // Preload all product images immediately when component mounts for instant display
  useEffect(() => {
    // Images are already preloaded by global preloader, but ensure they're ready here too
    products.forEach((product) => {
      if (product.image) {
        const img = new Image();
        // Set high fetch priority for faster loading
        if ('fetchPriority' in img) {
          img.fetchPriority = 'high';
        }
        img.src = product.image;
        // Use decode API for better performance
        if (img.decode) {
          img.decode().catch(() => {});
        }
      }
    });
  }, []);

  const handleProductClick = (route) => {
    // Check if it's an external URL (starts with http:// or https://)
    if (route.startsWith('http://') || route.startsWith('https://')) {
      window.open(route, '_blank', 'noopener,noreferrer');
    } else {
      // Internal route - use React Router
      history.push(route);
    }
  };

  return (
    <div className="products-page">
      {/* Products Grid Section */}
      <section className="products-grid-section">
        <div className="products-grid-container">
          {/* First Row - 3 products */}
          <div className="products-grid-row products-grid-row-first">
            {products.slice(0, 3).map((product) => (
              <div
                key={product.id}
                className="product-card-wrapper"
              >
                <div className="product-card">
                  <div className="product-card-front">
                    <div className="product-card-image-container">
                      <img
                        src={product.image}
                        alt={product.title}
                        className="product-card-image"
                        loading="eager"
                        fetchPriority="high"
                        decoding="async"
                      />
                      <div className="product-card-overlay"></div>
                    </div>
                    <div className="product-card-title">{product.title}</div>
                  </div>
                  <div className="product-card-back">
                    <div className="product-card-content">
                      <h3 className="product-card-back-title">{product.title}</h3>
                      <p className="product-card-description">{product.description}</p>
                      <span 
                        className="product-card-link"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleProductClick(product.route);
                        }}
                      >
                        View More →
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Second Row - 3 products */}
          <div className="products-grid-row products-grid-row-second">
            {products.slice(3, 6).map((product) => (
              <div
                key={product.id}
                className="product-card-wrapper"
              >
                <div className="product-card">
                  <div className="product-card-front">
                    <div className="product-card-image-container">
                      <img
                        src={product.image}
                        alt={product.title}
                        className="product-card-image"
                        loading="eager"
                        fetchPriority="high"
                        decoding="async"
                      />
                      <div className="product-card-overlay"></div>
                    </div>
                    <div className="product-card-title">{product.title}</div>
                  </div>
                  <div className="product-card-back">
                    <div className="product-card-content">
                      <h3 className="product-card-back-title">{product.title}</h3>
                      <p className="product-card-description">{product.description}</p>
                      <span 
                        className="product-card-link"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleProductClick(product.route);
                        }}
                      >
                        View More →
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Third Row - additional products */}
          {products.length > 6 && (
          <div className="products-grid-row products-grid-row-third">
            {products.slice(6, 9).map((product) => (
              <div
                key={product.id}
                className="product-card-wrapper"
              >
                <div className="product-card">
                  <div className="product-card-front">
                    <div className="product-card-image-container">
                      <img
                        src={product.image}
                        alt={product.title}
                        className="product-card-image"
                        loading="eager"
                        fetchPriority="high"
                        decoding="async"
                      />
                      <div className="product-card-overlay"></div>
                    </div>
                    <div className="product-card-title">{product.title}</div>
                  </div>
                  <div className="product-card-back">
                    <div className="product-card-content">
                      <h3 className="product-card-back-title">{product.title}</h3>
                      <p className="product-card-description">{product.description}</p>
                      <span 
                        className="product-card-link"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleProductClick(product.route);
                        }}
                      >
                        View More →
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Products;

